import { simpleFetch } from "./acCommon"

export const ACCOUNT_SECURITY_DATACHANGE = 'ACCOUNT_SECURITY_DATACHANGE'
export const accountSecurityDataChange = changes => ({ type: ACCOUNT_SECURITY_DATACHANGE, changes })

export const ACCOUNT_SECURITY_METACHANGE = 'ACCOUNT_SECURITY_METACHANGE'
export const accountSecurityMetaChange = changes => ({ type: ACCOUNT_SECURITY_METACHANGE, changes })

export const TOGGLE_ACCOUNT_SECURITY_MODAL = 'TOGGLE_ACCOUNT_SECURITY_MODAL'
export const toggleModal = () => ({type: TOGGLE_ACCOUNT_SECURITY_MODAL })

export const processDataChange = changes => (dispatch, getState) => {

	dispatch(accountSecurityDataChange(changes))

	let { oldPassword, newPassword, newPasswordConfirmation } = getState().dataReducer.accountSecurity

	if (oldPassword !== '' && newPassword !== '' && oldPassword !== newPassword && newPassword === newPasswordConfirmation) {
		dispatch(accountSecurityMetaChange({ canSubmit: true }))
	}
	else {
		dispatch(accountSecurityMetaChange({ canSubmit: false }))
	}
}

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE'

export const updatePassword = () => (dispatch, getState) => {

	let {
		dataReducer: {
			accountSecurity: { oldPassword, newPassword, newPasswordConfirmation}
		}
	} = getState()

	let body = JSON.stringify({
		old_password: oldPassword,
		password: newPassword,
		password_confirmation: newPasswordConfirmation
	})

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_update_password',
	}

	dispatch(simpleFetch('/customers/profile/', {
		method: 'PUT',
		body: body
	}, UPDATE_PASSWORD, requestMeta)).then(({ actionType, response, requestMeta }) => {
		dispatch(toggleModal())
	})
}


// WEBPACK FOOTER //
// ./src/actions/acAccountSecurity.js